import React from 'react';
import {Text, StyleSheet} from 'react-native';
import flexCheck from '../../../../utils/flexCheck';

const Texts = React.forwardRef((props, ref) => {
  const styles = StyleSheet.flatten(props.style);
  let updatedStyles = false;
  if (typeof props !== 'undefined' && typeof styles !== 'undefined') {
    updatedStyles = flexCheck(styles);
  }
  return (
    <>
      <Text
        ref={ref}
        {...props}
        style={updatedStyles ? updatedStyles : styles}
      />
    </>
  );
});
export default Texts;
